import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Button,
  Snackbar,
  Alert
} from "@mui/material";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import { useLocation, useNavigate } from "react-router-dom";
import RobotFileTempletPopUp from "../../output-components/test-automation/RobotFileTempletPopUp";
import KeywordDesignPopup from "../../output-components/test-automation/KeywordDesignPopup";

const SelectFrameWork = (props) => {
  const location = useLocation();
  const [framework, setFramework] = useState("");
  const [projectType, setProjectType] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [programmingLanguage, setProgrammingLanguage] = useState("");
  const [codeStyle, setCodeStyle] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [projectTypeOptions, setProjectTypeOptions] = useState([])
  const [isDisabled, setIsDisabled] = useState({
    //apiTesting: true,
    programmingLanguage: true,
    codeStyle: true,
    testDataSource: true,
    environment: true,
  });
  const navigate = useNavigate();
  // Update states based on framework selection
  useEffect(() => {
    switch (framework) {
      case "selenium-java":
        setIsDisabled({
          //apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("Java");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          { value: "new-test-case", label: "New Test Case - Existing Project" },
          { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "c-sharp":
        setIsDisabled({
          //apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("C#");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          // { value: "new-test-case", label: "New Test Case - Existing Projects" },
          // { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "robot-framework":
        setIsDisabled({
          // apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("Python");
        setCodeStyle("Keywords");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          // { value: "new-userstory", label: "New FSD/User Story - Existing Project" },
          { value: "existing-userstory", label: "New Test Case - Existing Project" },
          // { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "playwright-java":
        setIsDisabled({
          // apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("Java");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          { value: "new-test-case", label: "New Test Case - Existing Project" },
          { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "playwright-c-sharp":
        setIsDisabled({
          // apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("C#");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          { value: "new-test-case", label: "New Test Case - Existing Projects", disabled: true },
          { value: "modified-test-case", label: "Modified Test Case - Existing Project", disabled: true },
        ]);
        break;
      case "playwright-typescript":
        setIsDisabled({
          // apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("TypeScript");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          // { value: "newproject", label: "New Project" },
          { value: "new-test-case", label: "New Test Case - Existing Projects" },
          // { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "cypress-javascript":
        setIsDisabled({
          // apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("JavaScript");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          // { value: "new-test-case", label: "New Test Case - Existing Project" },
          // { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      case "java-testng":
        setIsDisabled({
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        })
        setProgrammingLanguage("Java");
        setCodeStyle("Page Object Model (POM)");
        setProjectTypeOptions([
          { value: "newproject", label: "New Test Case - New Project" },
          { value: "new-test-case", label: "New Test Case - Existing Project" },
          // { value: "modified-test-case", label: "Modified Test Case - Existing Project" },
        ]);
        break;
      default:
        setIsDisabled({
          //  apiTesting: true,
          programmingLanguage: true,
          codeStyle: true,
          testDataSource: true,
          environment: true,
        });
        setProgrammingLanguage("");
        setCodeStyle("");
    }
  }, [framework]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleConfirm = () => {
    console.log("=== SelectFrameWork handleConfirm ===");
    console.log("Selected framework:", framework);
    console.log("Selected project type:", projectType);
    console.log("Current location state:", location.state);
    if (projectType === "newproject" && (framework === "robot-framework" || framework === "selenium-java")) {
      const navigationState = { projectType: projectType, framework: framework };
      console.log("Navigating to new project with state:", navigationState);
      navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
        state: navigationState
      });
    } else if ((framework === "robot-framework" || framework === "selenium-java") && (projectType === "new-test-case" || projectType === "modified-test-case" || projectType === "existing-userstory")) {
      const navigationState = { framework: framework, projectType: projectType };
      console.log("Navigating to GitCredentialsPage with state:", navigationState);
      navigate(`/dashboard/test-automation/GitCredentialsPage`, {
        state: navigationState,
      });
    } else if (framework.startsWith("playwright-")) {
      // Handle Playwright frameworks
      if (projectType === "newproject") {
        const navigationState = { projectType: projectType, framework: framework };
        console.log("Navigating to new project with state:", navigationState);
        navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
          state: navigationState
        });
      } else if (projectType === "new-test-case" || projectType === "modified-test-case") {
        const navigationState = { framework: framework, projectType: projectType };
        console.log("Navigating to GitCredentialsPage with state:", navigationState);
        navigate(`/dashboard/test-automation/GitCredentialsPage`, {
          state: navigationState,
        });
      }
    } else if (framework === "c-sharp") {
      // Handle Playwright frameworks
      if (projectType === "newproject") {
        const navigationState = { projectType: projectType, framework: framework };
        console.log("Navigating to new project with state:", navigationState);
        navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
          state: navigationState
        });
      } else if (projectType === "new-test-case" || projectType === "modified-test-case") {
        const navigationState = { framework: framework, projectType: projectType };
        console.log("Navigating to GitCredentialsPage with state:", navigationState);
        navigate(`/dashboard/test-automation/GitCredentialsPage`, {
          state: navigationState,
        });
      }
    } else if (framework === "cypress-javascript") {
      // Handle Cypress JavaScript framework
      if (projectType === "newproject") {
        const navigationState = { projectType: projectType, framework: framework };
        console.log("Navigating to new project with state:", navigationState);
        navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
          state: navigationState
        });
      } else if (projectType === "new-test-case" || projectType === "modified-test-case") {
        const navigationState = { framework: framework, projectType: projectType };
        console.log("Navigating to GitCredentialsPage with state:", navigationState);
        navigate(`/dashboard/test-automation/GitCredentialsPage`, {
          state: navigationState,
        });
      }
    }  else if (framework === "java-testng"){
      // Handle Testng Framework
      if (projectType === "newproject") {
        const navigationState = { projectType: projectType, framework: framework };
        console.log("Navigating to new project with state:", navigationState);
        navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
          state: navigationState
        });
      } else if (projectType === "new-test-case" || projectType === "modified-test-case") {
        const navigationState = { framework: framework, projectType: projectType };
        console.log("Navigating to GitCredentialsPage with state:", navigationState);
        navigate(`/dashboard/test-automation/GitCredentialsPage`, {
          state: navigationState,
        });
      }
    }
    else {
      const navigationState = { framework: framework };
      console.log("Navigating to framework page with state:", navigationState);
      navigate(`/dashboard/test-automation/${framework}`, {
        state: navigationState,
      });
    }
    // new-userstory   existing-userstory
  };
  return (
    <>
      <Box
        sx={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "16px",
          margin: "16px auto",
          width: "45%",
          position: "relative",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Configure Preferences
        </Typography>
        {/* Framework Dropdown */}
        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel>UI Testing Framework</InputLabel>
          <Select
            value={framework}
            onChange={(e) => {
              const selected = e.target.value;
              setFramework(selected);
              if (selected === "robot-framework") {
                setShowSnackbar(true); // trigger the notification
              }
            }}
            label="UI Testing Framework"
          >
            <MenuItem value="selenium-java">
              SeleniumWebDriver - Java - Cucumber(BDD)
            </MenuItem>
            <MenuItem value="c-sharp">
              SeleniumWebDriver - C# - SpecFlow(BDD)
            </MenuItem>
            <MenuItem value="c-sharp-rr" disabled>
              SeleniumWebDriver - C# - ReqNRoll(BDD)
            </MenuItem>
            <MenuItem value="robot-framework">Robot Framework(KWD)</MenuItem>
            <MenuItem value="playwright-java">
              Playwright - Java - Cucumber(BDD)
            </MenuItem>
            <MenuItem value="playwright-c-sharp">
              Playwright - C# - SpecFlow(BDD)
            </MenuItem>
            <MenuItem value="playwright-c-sharp-rr" disabled>
              Playwright - C# - ReqNRoll(BDD)
            </MenuItem>
            <MenuItem value="playwright-python-behave" disabled>
              Playwright - Python - Behave(BDD)
            </MenuItem>
            <MenuItem value="playwright-typescript" >
              Playwright - TypeScript - PlaywrightTest(TDD)
            </MenuItem>
            <MenuItem value="cypress-javascript">
              Cypress - JavaScript - Mocha(TDD)
            </MenuItem>
            <MenuItem value="java-testng">
              SeleniumWebDriver - Java - TestNG
            </MenuItem>
          </Select>
        </FormControl>
        {/* API Testing Framework */}

        {/* Programming Language */}
        <FormControl
          fullWidth
          sx={{ my: 2 }}
          disabled={isDisabled.programmingLanguage}
        //style={programmingLanguage ? { backgroundColor: "#e3f2fd" } : {}}
        >
          <InputLabel>Programming Language</InputLabel>
          <Select
            value={programmingLanguage}
            label="Programming Language"
            sx={{
              "& .MuiSelect-select": {
                color: "black", // Ensures selected value text is black
              },
            }}
          >
            <MenuItem value="Java">Java</MenuItem>
            <MenuItem value="C#">C#</MenuItem>
            <MenuItem value="Python">Python</MenuItem>
            <MenuItem value="TypeScript">TypeScript</MenuItem>
            <MenuItem value="JavaScript">JavaScript</MenuItem>
          </Select>
        </FormControl>
        {/* Code Style Preferences */}
        <FormControl
          fullWidth
          sx={{ my: 2 }}
          disabled={isDisabled.codeStyle}
        //style={codeStyle ? {  backgroundColor: "#e3f2fd"  } : {}}
        >
          <InputLabel>Code Style Preferences</InputLabel>
          <Select value={codeStyle} label="Code Style Preferences">
            <MenuItem value="Page Object Model (POM)">
              Page Object Model (POM)
            </MenuItem>
            <MenuItem value="Keywords">Keywords</MenuItem>
          </Select>
        </FormControl>
        {/* Test Data Source */}
        {/* <FormControl
          fullWidth
          sx={{ my: 2 }}
          disabled={isDisabled.testDataSource}
        >
          <InputLabel>Test Data Source (Optional)</InputLabel>
          <Select label="Test Data Source (Optional)">
            <MenuItem value="Excel">Excel</MenuItem>
            <MenuItem value="CSV">CSV</MenuItem>
            <MenuItem value="TXT">TXT</MenuItem>
            <MenuItem value="DOCX">DOCX</MenuItem>
            <MenuItem value="PDF">PDF</MenuItem>
            <MenuItem value="DB">DB</MenuItem>
          </Select>
        </FormControl> */}
        {/* Environment */}
        {/* <FormControl fullWidth sx={{ my: 2 }} disabled={isDisabled.environment}>
          <InputLabel>Environment</InputLabel>
          <Select label="Environment">
            <MenuItem value="A">A</MenuItem>
            <MenuItem value="B">B</MenuItem>
          </Select>
        </FormControl> */}
        <FormControl  disabled = {!framework}
          fullWidth
          sx={{ my: 2 }}
        >
          <InputLabel sx={{
            fontWeight: 'bold',
          }}
          >Project Type</InputLabel>
          <Select value={projectType}
            onChange={(e) => setProjectType(e.target.value)}
            label="Project Type">
            {projectTypeOptions.map((item) => (
              <MenuItem key={item.value} value={item.value} disabled={item.disabled}>
                {item.label}
              </MenuItem>
            ))}

          </Select>
        </FormControl>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
          }}
        >
          <Button
            variant="contained"
            startIcon={<SendSharpIcon />}
            sx={{
              textTransform: "none",
              px: 3,
            }}
            disabled={!projectType} // Disable Confirm button if no framework selected
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Box>
      </Box>
      {/* <Snackbar
        open={showSnackbar}
        autoHideDuration={10000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setShowSnackbar(false)} severity="error" sx={{ width: '100%' }}>
          To proceed, please create or link a relevant User Story or Functional Specification Document (FSD).
        </Alert>
      </Snackbar> */}
      <KeywordDesignPopup
        open={showPopup}
        handleClose={handleClosePopup}
        framework={framework}
      />
    </>
  );
};
export default SelectFrameWork;
